/**
 * @generated SignedSource<<c6c06213395863c0bbd725c814b25a79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type noteTemplateGqlUnstarNoteTemplateMutation$variables = {
  id: string;
};
export type noteTemplateGqlUnstarNoteTemplateMutation$data = {
  readonly unstarNoteTemplate: {
    readonly template: {
      readonly id: string;
      readonly starred: boolean;
    };
  } | null;
};
export type noteTemplateGqlUnstarNoteTemplateMutation = {
  response: noteTemplateGqlUnstarNoteTemplateMutation$data;
  variables: noteTemplateGqlUnstarNoteTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "templateId",
        "variableName": "id"
      }
    ],
    "concreteType": "UnstarNoteTemplate",
    "kind": "LinkedField",
    "name": "unstarNoteTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteTemplateNode",
        "kind": "LinkedField",
        "name": "template",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "starred",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "noteTemplateGqlUnstarNoteTemplateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "noteTemplateGqlUnstarNoteTemplateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0787e26022a9e73d666c003c837f32a4",
    "id": null,
    "metadata": {},
    "name": "noteTemplateGqlUnstarNoteTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation noteTemplateGqlUnstarNoteTemplateMutation(\n  $id: ID!\n) {\n  unstarNoteTemplate(templateId: $id) {\n    template {\n      id\n      starred\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dfb2b617994f60819124a625c202b557";

export default node;
